import { PropsWithChildren, createContext, useState } from "react";

type NavigationSidebarType = {
  setCollapsed: (isCollapsed: boolean) => void;
  isCollapsed: boolean;
};

export const NavigationContext = createContext<NavigationSidebarType>({
  isCollapsed: false,
  setCollapsed() {
    console.warn("setCollapsed called but no NavigationContext was found.");
  },
});

export function NavigationProvider(props: PropsWithChildren) {
  const [isCollapsed, setCollapsed] = useState(false);

  return (
    <NavigationContext.Provider value={{ setCollapsed, isCollapsed }}>
      {props.children}
    </NavigationContext.Provider>
  );
}
